import { rem } from '@blueprint/ui';
import styled from 'styled-components/macro';

import { Select, Option } from 'components/blueprint';
import { useSafeLabel } from 'hooks';
import { useInteractionTracking } from 'tracking/hooks/useInteractionTracking';

import messages from './messages';

const SPECIAL_SELECT_CATEGORY_OPTION = 'SPECIAL_SELECT_CATEGORY_OPTION';

export const CATEGORY_SELECT_FIELD_ID = 'get-support-category-list-field';

const CategorySelect = styled(Select)`
  && {
    font-size: ${rem(14)};
    padding-left: ${rem(10)};
    padding-right: ${rem(50)};
    height: ${rem(40)};
  }
`;

/**
 * Category
 * top breadcrumb
 */
export const Category = ({
  breadcrumb = [],
  dropdown = [],
  onNavContextChange,
  isError,
}) => {
  const safeLabel = useSafeLabel();
  const trackCategorySelect = useInteractionTracking('dropdown');

  const handleCategorySelect = (category) => {
    const value = category.target?.value || '';

    trackCategorySelect({
      tealiumData: {
        event_content: `category: ${value.toLowerCase()} selected`,
      },
    })();

    if (value === SPECIAL_SELECT_CATEGORY_OPTION || !value) {
      return;
    }

    onNavContextChange(value);
  };

  const getBreadcrumbLabel = (breadcrumbItem) =>
    breadcrumbItem.displaycontext === 'Root'
      ? safeLabel(messages.topFaqs)
      : breadcrumbItem.displaycontext;

  return (
    <>
      <CategorySelect
        data-testid="category-select"
        onChange={handleCategorySelect}
        marginY={rem(20)}
        id={CATEGORY_SELECT_FIELD_ID}
        disabled={isError}
      >
        <Option
          key={SPECIAL_SELECT_CATEGORY_OPTION}
          value={SPECIAL_SELECT_CATEGORY_OPTION}
        >
          {safeLabel(
            breadcrumb.length > 1 && dropdown.length > 1
              ? messages.subCategory
              : messages.selectCategory,
          )}
        </Option>
        {breadcrumb.map((item) => (
          <Option key={item.navcontext} value={item.navcontext}>
            {getBreadcrumbLabel(item)}
          </Option>
        ))}
        {dropdown.map((item) => (
          <Option key={item.navcontext} value={item.navcontext}>
            {item.displaycontext}
          </Option>
        ))}
      </CategorySelect>
    </>
  );
};
